<div class="statement">
  <div class="statement-notes service-card">
    <div class="s-card-header ">
      <span class="flex-between-start flex-column">
        Unpaid Statement Summary
      </span>
    </div>


    <div class="s-card-body statement-service">
      <div class="s-card-row flex-start-center">
        <p class="m-0 name font-bold pr-2">Statement Name</p>
        <p class="m-0 total font-bold ">Total amount</p>
        <p class="m-0 total font-bold ">Paid to date</p>
        <p class="m-0 total font-bold ">Balance due</p>
      </div>

      <div class="s-card-row flex-start-center" *ngFor="let item of statementList; let itemIndex = index">

        <p class="m-0 name align-self-start">
          <span>{{item?.name}}</span>
        </p>
        <p class="m-0 total text-right align-self-start">{{item?.totalValue || 0 | currency: usd }}</p>
        <p class="m-0 total text-right align-self-start">{{item?.paid || 0 | currency: usd }}</p>
        <p class="m-0 total text-right align-self-start">{{item?.balanceDue || 0 | currency: usd }}</p>
      </div>
    </div>
    <div class="s-card-footer">
      <div class=" statement-service">
        <div class="s-card-row flex-start-center">
          <p class="m-0 name font-bold pr-2 ">Total</p>
          <p class="m-0 total font-bold ">{{statementTotal?.total || 0 | currency: usd }}</p>
          <p class="m-0 total font-bold ">{{statementTotal?.paid || 0 | currency: usd }}</p>
          <p class="m-0 total font-bold ">{{statementTotal?.due || 0 | currency: usd }}</p>
        </div>
      </div>

    </div>
  </div>
</div>